import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { DomSanitizer } from '@angular/platform-browser';
import { ExtraOptions, NavigationExtras, Router } from '@angular/router';
import { ActionSheetController, MenuController, ModalController, Platform } from '@ionic/angular';
import { AppComponent } from 'src/app/app.component';
import { AuthService } from 'src/app/services/auth.service';
import { BootScene } from '../roza-wiatrow/roza-wiatrow.page';
import { WelcomePage } from '../welcome/welcome.page';

@Component({
  selector: 'app-kompas',
  templateUrl: './kompas.page.html',
  styleUrls: ['./kompas.page.scss'],
})
export class KompasPage implements OnInit {


  game = {
    width: '100%',
    height: 300,
    type: 'AUTO',
    scene: BootScene,
    instance: null
  };

  wwwLink: string;
  cleanSupportURL: any;
  szer = '100%';
  wysoko = '2050px';
  ifrejm: any;
  startPlaying = true;
  // observableVar: Subscription;
  userData;
  isLoggedIn = false;
  account;
  shownProfileData;

  canContinue = false;
  canSeeResults = false;

  actionSheet;

  constructor(public auth: AuthService, public platform: Platform, public sanitizer: DomSanitizer,
              public menu: MenuController, public afa: AngularFireAuth, public router: Router,
              public modalController: ModalController, public actionSheetController: ActionSheetController,
              private afs: AngularFirestore, private app: AppComponent)
  {

    this.initiatePlatformIfReady();
    this.userData = afa.authState;
    //  // console.log('afa', this.userData.uid);
  }

  ngOnInit() {

    // this.menu.enable(true, 'main');
    window.addEventListener('event', (event) => {
       // console.log('MSG', event);
    }, false);

    const link = 'assets/kompas/iindex.html';
    this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);
    this.ifrejm = document.getElementById('ifrejm');
    // this.ifrejm.addEventListener('mouseup', this.onIframeHandler);

    this.afa.authState.subscribe(user => {

      this.resizeAll();

      if (user)
      {
        this.account = user;
         // console.log('afa user', this.account.uid);
        this.auth.myId = this.account.uid;
        // this.auth.czekAccount();
        this.isLoggedIn = true;

        this.shownProfileData = this.auth.getKompasData(this.auth.myId).subscribe((data) => {

           // console.log('getKompasData?', data);

          if (data === undefined)
          {
             // console.log('nie ma jeszcze takiego AKWENU');
            this.canContinue = true;

            const quizk: any = JSON.parse(localStorage.getItem('quiz'));
            if (quizk)
            {
               // console.log('quizk', quizk);
              if (quizk.qn > 0)
              {
                this.presentActionSheet();
              }
            }
            else
            {
               // console.log('begginer');
            }
          }
          else
          {
             // console.log('juz jest AKWEN', data);
            // this.gotoProfile();
            this.canSeeResults = true;
            this.presentActionSheet2();
          }
        });
      }
      else {

         // console.log('BRAK KOLO');
        // this.isLoggedIn = false;
        if (!window.localStorage.getItem('introBylo'))
        {
          this.presentModal();
          window.localStorage.setItem('introBylo', 'true');
        }

      }
    });
  }

  onIframeHandler() {
     // console.log('onIframeHandler');
  }
  continueKompas()
  {
    const link = 'assets/kompas/quiz.html';
    this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);
  }

  async presentActionSheet() {

    if (this.actionSheet)
    {
      this.actionSheet.dismiss();
      this.actionSheet = null;
    }

    this.actionSheet = await this.actionSheetController.create({
      header: 'Czy chcesz kontynuować pomiary Kompasa Piratów?',
      mode: 'md',
      buttons: [
      {
        text: 'Kontynuuj pomiary!',
        icon: 'locate-outline',
        handler: () => {
           // console.log('Otwieraj clicked');
          const link = 'assets/kompas/quiz.html';
          this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);
        }
      },
      {
        text: 'Zacznij pomiary od nowa!',
        icon: 'refresh',
        handler: () => {
           // console.log('Otwieraj clicked');
          localStorage.setItem('quiz', null);
          const link = 'assets/kompas/quiz.html';
          this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);
        }
      }, {
        text: 'Pokaż mapę',
        icon: 'map-outline',
        handler: () => {
           // console.log('Otwieraj clicked');
          this.router.navigate(['/maps/']);
        }
      }, {
        text: 'Moze później...',
        icon: 'close',
        role: 'cancel',
        handler: () => {
           // console.log('Cancel clicked');
        }
      }]
    });
    await this.actionSheet.present();
  }

  refresz()
  {
    localStorage.setItem('quiz', null);
    const link = 'assets/kompas/quiz.html';
    this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);
  }

  async presentActionSheet2() {
    if (this.actionSheet)
    {
      this.actionSheet.dismiss();
      this.actionSheet = null;
    }

    this.actionSheet = await this.actionSheetController.create({
      header: 'Czy chcesz zobaczyć swoje wyniki Kompasa Piratów?',
      mode: 'md',
      buttons: [
      {
        text: 'Otwórz swój akwen',
        icon: 'aperture-outline',
        handler: () => {
           // console.log('Otwieraj clicked');
          this.router.navigate(['/profile/', this.auth.myId]);
          const linkQ = 'assets/kompas/quiz.html';
          this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(linkQ);
        }
      }, {
        text: 'Pokaż mapę archipelagu',
        icon: 'map-outline',
        handler: () => {
           // console.log('Otwieraj clicked');
          this.router.navigate(['/maps/']);
        }
      }, {
        text: 'Zobacz zwiastun!',
        icon: 'logo-youtube',
        handler: () => {
          this.presentModal();
        }
      }, {
        text: 'Zrób test od nowa!',
        icon: 'refresh',
        handler: () => {
           // console.log('Otwieraj clicked');
          this.afs.collection('accounts').doc(this.auth.myId).delete().then(() => {
              localStorage.setItem('quiz', null);
               // console.log('Document successfully deleted!');
              const linkR = 'assets/kompas/quiz.html';
              this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(linkR);
          }).catch((error) => {
              alert('Error removing document: ' + error);
          });
        }
      }, {
        text: 'Może później...',
        icon: 'close',
        role: 'cancel',
        handler: () => {
           // console.log('Cancel clicked');
        }
      }]
    });
    await this.actionSheet.present();
  }

  async presentModal() {
    // this.app.isMuted = true;
    // this.app.flipMuted();
    const modal = await this.modalController.create({
      component: WelcomePage,
      cssClass: 'welcome-modal'
    });
    return await modal.present();
  }

  goBackToStart()
  {
    //  // console.log('goBackToStart111');
    this.menu.open();

    const link = 'assets/kompas/iindex.html';
    this.cleanSupportURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);

    // this.menu.toggle('main-content');

  }

  goto8values()
  {
    (window).open('https://github.com/PirateForge/PirateCompass');
  }

  getInnerWidth(elem) {

    let last = parseFloat(window.getComputedStyle(elem).width);
    if (last > 800)
    {
      last = 800;
    }
    return last;
  }
  gotoArchipelag()
  {
    this.router.navigate(['/maps/']);
  }
  gotoSkarbiec()
  {
    this.router.navigate(['/skrzynia/']);
  }

  gotoProfile()
  {
     // console.log('gotoProfile', this.auth.myId);
    // await this.app.awaitFunction(2000);
    const extras: NavigationExtras = {
      replaceUrl : true
    };
    this.router.navigate(['/profile/', this.auth.myId], extras);
  }


  resizeAll()
  {
    //  // console.log('resized', this.szer);

    if (!this.ifrejm)
    {
      // this.wysoko = (this.getInnerWidth(window.document.body) * 0.5625) + "px"
      // this.szer = this.getInnerWidth(window.document.body) + "px";
      //  // console.log('resizeAll XXX', this.szer);
    }
    else
    {
      // this.wysoko = (this.getInnerWidth(this.ifrejm) * 0.5625) + "px"
      // this.szer = this.getInnerWidth(this.ifrejm) + "px";
      //  // console.log('resizeAll ifrejm', this.szer);
    }
  }

  initiatePlatformIfReady() {
    this.platform.ready().then(() => {
       // console.log('KOMPAS before subscribe');

      this.platform.resize.subscribe(() => {
        //  // console.log('initiatePlatformIfReady');
        this.resizeAll();
      });
    });
  }

}
